import { useState } from 'react'
import CustomButton from '../CustomButton'
import axiosInstance from '../../utils/axiosInstance'
import { toast } from 'react-toastify'
import { ParseErrors } from '../../utils/ParseErrors'
import Loader from '../Loader'
import ModalPortal from '../modal-portal'

interface TDeleteAgentModel {
    ToggleDeleteModel: () => void,
    id: number
}

const DeleteAgentModel = ({ ToggleDeleteModel, id }: TDeleteAgentModel) => {
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const deleteUser = async () => {
        setIsLoading(true)
        try {
            const res = await axiosInstance.delete(`/user/delete/${id}`)
            toast.success(res.data.message)
            setIsLoading(false)
            ToggleDeleteModel()
        } catch (error) {
            console.log(error)
            toast.error(ParseErrors(error))
            setIsLoading(false)
        }
    }


    return (
        <ModalPortal>
            <div
                className="z-[99999] fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center px-4 animate-fade-in"
                onClick={() => !isLoading && ToggleDeleteModel()}
            >
                <div
                    className="bg-surface border border-edge w-full max-w-[500px] rounded-2xl shadow-overlay px-6 sm:px-8 py-6 smallTablet:max-h-[90dvh] smallTablet:overflow-y-auto"
                    onClick={(e) => e.stopPropagation()}
                >
                    <h2 className="font-heading-font text-[24px] sm:text-[30px] bg-gradient-heading bg-clip-text text-transparent leading-tight">Are you sure you wanna delete ?</h2>

                    <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-3 mt-8">
                        <CustomButton disabled={isLoading} className="bg-overlay-mid border border-edge-faint hover:border-indigo-400/40 cursor-pointer rounded-lg h-[44px] px-6 font-[400] !text-[16px] text-text-primary transition-all" onClick={() => ToggleDeleteModel()}>Cancel</CustomButton>
                        <CustomButton disabled={isLoading} className="bg-red-500/15 border border-red-500/30 hover:bg-red-500/25 cursor-pointer rounded-lg h-[44px] px-8 font-[400] !text-[16px] !text-red-400 transition-all" onClick={deleteUser}>{isLoading ? <Loader /> : "Delete"}</CustomButton>
                    </div>
                </div>
            </div>
        </ModalPortal>
    )
}

export default DeleteAgentModel
